import { Errors } from 'const/errors';

export class MyError<T = any> extends Error {
  constructor(public type: Errors, public payload?: T) {
    super(type);
  }
}
